import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
	standalone: true,
	imports: [CommonModule],
	template: `
		<div class="modal-header">
			<h5 class="modal-title">Torfarten, Muddearten &amp; Quellsedimente</h5>
			<button type="button" class="btn-close" aria-label="Schließen" (click)="activeModal.dismiss()"></button>
		</div>
		<div class="modal-body">
			<div class="table-row">
				<div class="table-col">
					<h6>Torfarten</h6>
					<table class="table table-sm table-bordered arten-table">
						<thead>
							<tr>
								<th>Einheit</th>
								<th>Untereinheit</th>
								<th>Kürzel</th>
								<th>Bezeichnung</th>
							</tr>
						</thead>
						<tbody>
							<tr><td rowspan="5"><strong>h-h</strong></td><td></td><td></td><td>Holztorf</td></tr>
							<tr><td></td><td>h-hk</td><td>Kiefernbruchtorf</td></tr>
							<tr><td></td><td>h-hi</td><td>Birkenbruchtorf</td></tr>
							<tr><td></td><td>h-he</td><td>Erlenbruchtorf</td></tr>
							<tr><td></td><td>h-hr</td><td>Reisertorf</td></tr>
							<tr><td rowspan="3"><strong>h-m</strong></td><td></td><td></td><td>Moostorf</td></tr>
							<tr><td>h-mb</td><td></td><td>Torfmoostorf</td></tr>
							<tr><td>h-ml</td><td></td><td>Braunmoostorf</td></tr>
							<tr><td rowspan="9"><strong>h-r</strong></td><td></td><td></td><td>Riedtorf</td></tr>
							<tr><td></td><td>h-rw</td><td>Wollgrastorf</td></tr>
							<tr><td></td><td>h-rb</td><td>Blasenbinsentorf</td></tr>
							<tr><td></td><td>h-rs</td><td>Seggentorf</td></tr>
							<tr><td></td><td class="indent">h-rsg</td><td class="indent">Grobseggentorf</td></tr>
							<tr><td></td><td class="indent">h-rsf</td><td class="indent">Feinseggentorf</td></tr>
							<tr><td></td><td>h-rf</td><td>Salzweidentorf</td></tr>
							<tr><td></td><td>h-rc</td><td>Schneidentorf</td></tr>
							<tr><td></td><td>h-rp</td><td>Schilftorf</td></tr>
							<tr><td><strong>h-a</strong></td><td></td><td></td><td>amorpher Torf</td></tr>
						</tbody>
					</table>
				</div>
				<div class="table-col">
					<h6>Muddearten</h6>
					<table class="table table-sm table-bordered arten-table">
						<thead>
							<tr>
								<th>Einheit</th>
								<th>Kürzel</th>
								<th>Bezeichnung</th>
								<th>org. %</th>
								<th>CaCO₃ %</th>
								<th>Silikat %</th>
							</tr>
						</thead>
						<tbody>
							<tr class="group-header"><td rowspan="6"><strong>y-o</strong></td><td></td><td>Organomudde</td><td>≥ 30</td><td>&lt;70</td><td>&lt;70</td></tr>
							<tr><td>y-of</td><td>Feindetritusmudde</td><td></td><td></td><td></td></tr>
							<tr><td>y-om</td><td>Mitteldetritusmudde</td><td></td><td></td><td></td></tr>
							<tr><td>y-og</td><td>Grobdetritusmudde</td><td></td><td></td><td></td></tr>
							<tr><td>y-ol</td><td>Lebermudde</td><td></td><td></td><td></td></tr>
							<tr><td>y-ot</td><td>Torfmudde</td><td></td><td></td><td></td></tr>
							<tr><td></td><td>y-ob</td><td>Laubmudde</td><td></td><td></td><td></td></tr>
							<tr class="group-header"><td rowspan="3"><strong>y-c</strong></td><td></td><td>Kalkmudde</td><td>&gt;5–&lt;30</td><td>≥30–95</td><td>&lt;70</td></tr>
							<tr><td>y-cf</td><td>Feindetrituskalkmudde</td><td></td><td></td><td></td></tr>
							<tr><td>y-cg</td><td>grobpflanzliche Kalkmudde</td><td></td><td></td><td></td></tr>
							<tr class="group-header"><td rowspan="4"><strong>y-s</strong></td><td></td><td>Silikatmudde</td><td>&gt;5–&lt;30</td><td>&lt;30</td><td>≥30–95</td></tr>
							<tr><td>y-st</td><td>Tonmudde</td><td></td><td></td><td></td></tr>
							<tr><td>y-su</td><td>Schluffmudde</td><td></td><td></td><td></td></tr>
							<tr><td>y-ss</td><td>Sandmudde</td><td></td><td></td><td></td></tr>
						</tbody>
					</table>
				</div>
			</div>

			<h6 class="mt-3">Quellsedimente</h6>
			<table class="table table-sm table-bordered arten-table quellsediment-table">
				<thead>
					<tr>
						<th>Kürzel</th>
						<th>Bezeichnung</th>
						<th>CaCO₃</th>
						<th>Silikatgehalt</th>
					</tr>
				</thead>
				<tbody>
					<tr><td><strong>q-c</strong></td><td>Quellkalk</td><td>&gt;10 %</td><td></td></tr>
					<tr><td><strong>q-s</strong></td><td>silikatreiches Quellsediment</td><td></td><td>&gt;30 %</td></tr>
					<tr><td><strong>q-o</strong></td><td>organisch reiches hochzersetztes Quellsediment</td><td>&lt;10 %</td><td>&lt;30 %</td></tr>
				</tbody>
			</table>
			<p class="text-muted small mt-1 mb-0">Sedimente in Quellmooren sind als solche auszuweisen.</p>

			<p class="text-muted small mt-2 mb-0">Quelle: SEA TeilA, S. 79–81</p>
		</div>
	`,
	styles: [`
		.table-row {
			display: flex;
			gap: 1.5rem;
			flex-wrap: wrap;
		}
		.table-col {
			flex: 1;
			min-width: 280px;
		}
		.arten-table {
			font-size: 0.82rem;
		}
		.arten-table th {
			text-align: center;
			vertical-align: middle;
			background: #f8f9fa;
		}
		.arten-table td {
			white-space: nowrap;
		}
		.arten-table td:first-child {
			vertical-align: middle;
			text-align: center;
		}
		.indent {
			padding-left: 1.2rem !important;
			font-size: 0.78rem;
		}
		.group-header td {
			border-top: 2px solid #dee2e6;
		}
		.quellsediment-table {
			max-width: 500px;
		}
		h6 {
			font-weight: 600;
		}
	`]
})
export class TorfMuddeArtenInfoModalComponent {
	activeModal = inject(NgbActiveModal);
}
